module.exports = __webpack_public_path__ + "static/media/calendar.f831728a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/cases/influencers/assets/calendar.png
// module id = 298
// module chunks = 0